import colors from "theme/theme-light/colors";

const { background } = colors;

const contained = {
  containedPrimary: {
    backgroundColor: background.bgBrand,
    "&:hover": {
      backgroundColor: background.bgBrand,
    },
  },

  containedSuccess: {
    backgroundColor: background.bgPositive,
    "&:hover": {
      backgroundColor: background.bgPositive,
    },
  },

  containedError: {
    backgroundColor: background.bgNegative,
    "&:hover": {
      backgroundColor: background.bgNegative,
    },
  },

  containedWarning: {
    backgroundColor: background.bgWarning,
    "&:hover": {
      backgroundColor: background.bgWarning,
    },
  },
};

export default contained;
